
export const UPDATE_PASSWORD = `
mutation updatePassword($password: String!) {
    updatePassword(password: $password)
}
`;
